import { ReactNode, useMemo } from "react";
import ReactGA from "react-ga4";
import { getStableId, getVariant } from "./bucketing";
import { EXPERIMENTS } from "./experiments.config";

// Optional infrastructure component for handbook parity. Hooks resolve identity
// from localStorage on demand, so the app works without mounting this — but
// when mounted it (1) seeds GA4 user_properties with the active assignments so
// every subsequent event is tagged, and (2) warms the bucket cache once.
//
// Mounting is safe at any tree depth since this depends on no other context.
const ExperimentProvider = ({ children }: { children: ReactNode }) => {
  useMemo(() => {
    const identity = getStableId();
    const assignments: Record<string, string> = {};
    for (const key of Object.keys(EXPERIMENTS)) {
      const exp = EXPERIMENTS[key];
      if (exp.status !== "running") continue;
      assignments[key] = getVariant(identity, exp);
    }

    try {
      ReactGA.set({ user_properties: { ab_assignments: JSON.stringify(assignments) } });
    } catch {
      // ReactGA may be uninitialised; the per-event Lambda Pixel emit still
      // carries experiment_id + variant_id in custom, so this is best-effort.
    }
  }, []);

  return <>{children}</>;
};

export default ExperimentProvider;
